import React from 'react';
import SGTitle from 'components/Typography/SGTitle';
import SGSubtitle from 'components/Typography/SGSubtitle';
import styled from 'styled-components';
import DeviceType, {DeviceTypeString} from 'features/POSRegisters/interfaces/DeviceType';

const StyledDetailsContainer = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  gap: 16px;
  padding-top: 8px;
`;

const StyledDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export default function RegisterDetails({
  deviceName,
  deviceType,
  model,
  serialNumber,
  ipAddress,
  macAddress,
  switchId,
  switchNumber,
  portNumber,
}: any) {
  return (
    <StyledDetailsContainer>
      {deviceName && (
        <StyledDetails>
          <SGTitle className="t6">Device Name</SGTitle>
          <SGSubtitle className="s2">{deviceName}</SGSubtitle>
        </StyledDetails>
      )}

      <StyledDetails>
        <SGTitle className="t6">Device</SGTitle>
        <SGSubtitle className="s2">
          {DeviceTypeString[deviceType as DeviceType] ?? deviceType}
        </SGSubtitle>
      </StyledDetails>
      {ipAddress && (
        <StyledDetails>
          <SGTitle className="t6">IP Address</SGTitle>
          <SGSubtitle className="s2">{ipAddress}</SGSubtitle>
        </StyledDetails>
      )}
      {macAddress && (
        <StyledDetails>
          <SGTitle className="t6">MAC Address</SGTitle>
          <SGSubtitle className="s2">{macAddress}</SGSubtitle>
        </StyledDetails>
      )}
      {switchId && (
        <StyledDetails>
          <SGTitle className="t6">Switch ID</SGTitle>
          <SGSubtitle className="s2">{switchId}</SGSubtitle>
        </StyledDetails>
      )}
      {switchNumber && (
        <StyledDetails>
          <SGTitle className="t6">Switch Number</SGTitle>
          <SGSubtitle className="s2">{switchNumber}</SGSubtitle>
        </StyledDetails>
      )}
      {portNumber && (
        <StyledDetails>
          <SGTitle className="t6">Port Number</SGTitle>
          <SGSubtitle className="s2">{portNumber}</SGSubtitle>
        </StyledDetails>
      )}
      {model && (
        <StyledDetails>
          <SGTitle className="t6">Model</SGTitle>
          <SGSubtitle className="s2">{model}</SGSubtitle>
        </StyledDetails>
      )}
      {serialNumber && (
        <StyledDetails>
          <SGTitle className="t6">Serial Number</SGTitle>
          <SGSubtitle className="s2">{serialNumber ?? ''}</SGSubtitle>
        </StyledDetails>
      )}
    </StyledDetailsContainer>
  );
}
